import { render, staticRenderFns } from "./LabelDesc.vue?vue&type=template&id=34c75e07&scoped=true&"
import script from "./LabelDesc.vue?vue&type=script&lang=js&"
export * from "./LabelDesc.vue?vue&type=script&lang=js&"
import style0 from "./LabelDesc.vue?vue&type=style&index=0&id=34c75e07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c75e07",
  null
  
)

export default component.exports